module.exports = __webpack_public_path__ + "img/79.fc100240.jpg";